import {
  Component,
  OnInit,
  ViewChild,
  Renderer2,
  ElementRef,
} from "@angular/core";
import { appService } from "../../app/_services/app.service";
import { DatePipe } from "@angular/common";
import { TranslateConfigService } from "../theme/home/translateConfig.service";
import { TranslateService } from "@ngx-translate/core";
const LNG_KEY = "SELECTED_LANGUAGE";

declare var jquery: any;
declare var $: any;

@Component({
  selector: "app-freightconfirmation",
  templateUrl: "./freightconfirmation.component.html",
  styleUrls: ["./freightconfirmation.component.scss"],
})
export class FreightconfirmationComponent implements OnInit {
  selectedLang: string;
  FCBasicDetails: any = [];
  PrimaryDistData: any = [];
  SecondaryDistData: any = [];
  PrimaryDeliveryDeatils: any = [];
  SecondaryDeliveryDetails: any = [];
  PrimaryLR: any = [];
  SecondaryLR: any = [];
  TotalMDC: any = 0;
  TotalPODC: any = 0;
  TotalGHC: any = 0;

  TotalPrimaryRate: any = 0;
  TotalSecondaryRate: any = 0;
  TotalRate: any = 0;

  UnplannedLoad: any = 0;
  BookingStatus: any = "";

  today: any;
  FCPrintFor: any;
  CourierDetail: any = [];
  @ViewChild("someVar") el: ElementRef;
  constructor(
    private _appService: appService,
    public datepipe: DatePipe,
    private service: TranslateConfigService,
    private translate: TranslateService
  ) {
    let language = this.translate.getBrowserLang();
    let value = localStorage.getItem(LNG_KEY);
    if (value === "" || value === null || value === undefined) {
      this.translate.setDefaultLang(language);
      this.selectedLang = language;
    } else {
      this.service.setLanguage(value);
      this.selectedLang = value;
    }
    let val = localStorage.getItem(LNG_KEY);
  }

  ngOnInit() {
    // test dhwani1
  }

  GetFCBasicDetails(QuoteData, watermark, From, For) {
    this.FCPrintFor = For;
    // ************************ FTL ********************************
    if (this.FCPrintFor == "FTL") {
      this.BookingStatus = watermark;
      this.FCBasicDetails = QuoteData.FCPrintData.FCBasicDetails;

      var p = 0;
      this.UnplannedLoad = QuoteData.FCPrintData.FCBasicDetails.ProductWeight;
      for (
        let i = 0;
        i < QuoteData.FCPrintData.PrimaryDeliveryDeatils.length;
        i++
      ) {
        if (
          QuoteData.FCPrintData.PrimaryDeliveryDeatils[i].DeliveryType == "P"
        ) {
          this.PrimaryLR[p] = {};

          this.PrimaryLR[p].LRNumber =
            QuoteData.FCPrintData.PrimaryDeliveryDeatils[i].LRNO;
          this.PrimaryLR[p].NoOfOrders =
            QuoteData.FCPrintData.PrimaryDeliveryDeatils[i].NoOfOrders;
          this.PrimaryLR[p].ProductWeight =
            Math.round(
              QuoteData.FCPrintData.PrimaryDeliveryDeatils[i].Weight * 100
            ) / 100;
          this.PrimaryLR[p].FromCityPin =
            QuoteData.FCPrintData.PrimaryDeliveryDeatils[i].FromCityPin;
          this.PrimaryLR[p].ToCityPin =
            QuoteData.FCPrintData.PrimaryDeliveryDeatils[i].ToCityPin;
          this.PrimaryLR[p].Distance =
            QuoteData.FCPrintData.PrimaryDeliveryDeatils[i].KM;
          this.PrimaryLR[p].MDC =
            QuoteData.FCPrintData.PrimaryDeliveryDeatils[i].MDC;
          this.PrimaryLR[p].ODC =
            QuoteData.FCPrintData.PrimaryDeliveryDeatils[i].PODC;

          this.PrimaryDeliveryDeatils[p] = {};
          this.PrimaryDeliveryDeatils[p].DeliveryAddress =
            QuoteData.FCPrintData.PrimaryDeliveryDeatils[i].ToAddress;
          this.PrimaryDeliveryDeatils[p].ContactNo =
            QuoteData.FCPrintData.PrimaryDeliveryDeatils[i].ContactNo;
          this.PrimaryDeliveryDeatils[p].CustomerType =
            QuoteData.FCPrintData.PrimaryDeliveryDeatils[i].CustomerType;

          if (
            QuoteData.FCPrintData.PrimaryDeliveryDeatils[i].CustomerType == "D"
          ) {
            this.UnplannedLoad =
              this.UnplannedLoad - this.PrimaryLR[p].ProductWeight;
          }
          p++;
        }
      }

      var s = 0;

      for (
        let i = 0;
        i < QuoteData.FCPrintData.PrimaryDeliveryDeatils.length;
        i++
      ) {
        if (
          QuoteData.FCPrintData.PrimaryDeliveryDeatils[i].DeliveryType == "S"
        ) {
          this.SecondaryLR[s] = {};
          this.SecondaryLR[s].LRNumber =
            QuoteData.FCPrintData.PrimaryDeliveryDeatils[i].LRNO;
          this.SecondaryLR[s].ProductWeight =
            Math.round(
              QuoteData.FCPrintData.PrimaryDeliveryDeatils[i].Weight * 100
            ) / 100;
          this.SecondaryLR[s].VehicleType =
            QuoteData.FCPrintData.PrimaryDeliveryDeatils[i].VehicleType;
          this.SecondaryLR[s].FromCityPin =
            QuoteData.FCPrintData.PrimaryDeliveryDeatils[i].FromCityPin;
          this.SecondaryLR[s].ToCityPin =
            QuoteData.FCPrintData.PrimaryDeliveryDeatils[i].ToCityPin;
          this.SecondaryLR[s].Customer =
            QuoteData.FCPrintData.PrimaryDeliveryDeatils[i].Customer;
          this.SecondaryLR[s].Distance =
            QuoteData.FCPrintData.PrimaryDeliveryDeatils[i].KM;
          this.SecondaryLR[s].GHC =
            QuoteData.FCPrintData.PrimaryDeliveryDeatils[i].GHC;
          this.SecondaryLR[s].SODC =
            QuoteData.FCPrintData.PrimaryDeliveryDeatils[i].SODC;

          this.UnplannedLoad =
            this.UnplannedLoad - this.SecondaryLR[s].ProductWeight;
          this.SecondaryDeliveryDetails[s] = {};
          this.SecondaryDeliveryDetails[s].DeliveryAddress =
            QuoteData.FCPrintData.PrimaryDeliveryDeatils[i].ToAddress;
          this.SecondaryDeliveryDetails[s].ContactNo =
            QuoteData.FCPrintData.PrimaryDeliveryDeatils[i].ContactNo;
          s++;
        }
      }
      this.UnplannedLoad = Math.round((this.UnplannedLoad * 100) / 100);
      this.PrimaryDistData = QuoteData.FCPrintData.PrimaryDistData;
      this.SecondaryDistData = QuoteData.FCPrintData.SecondaryDistData;

      if (
        QuoteData.FCDetailList[0] != undefined &&
        QuoteData.FCDetailList[0] != null
      ) {
        this.TotalPrimaryRate =
          parseInt(QuoteData.FCDetailList[0].PDFR || 0) +
          parseInt(QuoteData.FCDetailList[0].MDC || 0) +
          parseInt(QuoteData.FCDetailList[0].ODC || 0);
        // this.TotalSecondaryRate = parseInt(QuoteData.FCDetailList[0].GHC || 0) + parseInt(QuoteData.FCDetailList[0].SODC || 0) + parseInt(QuoteData.FCDetailList[0].SDFR || 0);

        for (let i = 0; i < this.PrimaryDistData.length; i++) {
          for (let j = 0; j < QuoteData.FCDetailList.length; j++) {
            if (QuoteData.FCDetailList[j].DeliveryType == "P") {
              if (this.PrimaryDistData[i].ChargeCode == "PDFR") {
                this.PrimaryDistData[i].Rate = parseInt(
                  QuoteData.FCDetailList[0].PDFR || 0
                );
              }
              if (this.PrimaryDistData[i].ChargeCode == "MDC") {
                this.PrimaryDistData[i].Rate = parseInt(
                  QuoteData.FCDetailList[0].MDC || 0
                );
              }
              if (this.PrimaryDistData[i].ChargeCode == "PODC") {
                this.PrimaryDistData[i].Rate = parseInt(
                  QuoteData.FCDetailList[0].ODC || 0
                );
              }
            }
          }
        }

        for (let i = 0; i < this.SecondaryDistData.length; i++) {
          for (let j = 0; j < QuoteData.FCDetailList.length; j++) {
            if (QuoteData.FCDetailList[j].DeliveryType == "S") {
              if (this.SecondaryDistData[i].ChargeCode == "SDC") {
                this.SecondaryDistData[i].Rate =
                  parseInt(this.SecondaryDistData[i].Rate || 0) +
                  parseInt(QuoteData.FCDetailList[j].GHC || 0);
              }
              if (this.SecondaryDistData[i].ChargeCode == "SDFR") {
                this.SecondaryDistData[i].Rate =
                  parseInt(this.SecondaryDistData[i].Rate || 0) +
                  parseInt(QuoteData.FCDetailList[j].SDFR || 0);
              }
            }

            if (From == "Booking") {
              this.TotalSecondaryRate =
                parseInt(QuoteData.FCDetailList[0].GHC || 0) +
                parseInt(QuoteData.FCDetailList[0].SODC || 0) +
                parseInt(QuoteData.FCDetailList[0].SDFR || 0);
            } else {
              this.TotalSecondaryRate =
                parseInt(this.TotalSecondaryRate || 0) +
                parseInt(this.SecondaryDistData[i].Rate || 0);
            }
          }
        }
        this.TotalRate =
          parseInt(this.TotalPrimaryRate || 0) +
          parseInt(this.TotalSecondaryRate || 0);
      }
    }
    if (this.FCPrintFor == "Courier") {
      this.TotalRate = QuoteData.Total;
      this.BookingStatus = watermark;
      this.FCBasicDetails =
        QuoteData.FCHeader.FCPrintCourierData.FCBasicDetails;
      this.CourierDetail =
        QuoteData.FCHeader.FCPrintCourierData.CourierPrintDetail;
    }
    if (this.FCPrintFor == "FTLTrans") {
      this.BookingStatus = watermark;
      this.FCBasicDetails = QuoteData;
      this.today = Date.now();
    }
  }

  GetInnerHTML() {
    var pdfhtml = document.getElementById("someVar").innerHTML;
    return pdfhtml;
  }
  GetHtml(resolvefunc: any) {
    setTimeout(() => {
      var pdfhtml = document.getElementById("someVar").innerHTML;
      resolvefunc(pdfhtml);
    }, 200);
  }

  GetCourierHtml(resolvefunc: any) {
    setTimeout(() => {
      var pdfhtml = document.getElementById("FCForCourier").innerHTML;
      resolvefunc(pdfhtml);
    }, 200);
  }

  GetFTLHtml(resolvefunc: any) {
    setTimeout(() => {
      var pdfhtml = document.getElementById("FCForFTLTrans").innerHTML;
      resolvefunc(pdfhtml);
    }, 200);
  }

  ClearFCPRintData() {
    this.FCBasicDetails = {};
    this.PrimaryDistData = [];
    this.SecondaryDistData = [];
    this.PrimaryDeliveryDeatils = [];
    this.SecondaryDeliveryDetails = [];
    this.PrimaryLR = [];
    this.SecondaryLR = [];

    this.TotalMDC = 0;
    this.TotalPODC = 0;
    this.TotalGHC = 0;

    this.TotalPrimaryRate = 0;
    this.TotalSecondaryRate = 0;
    this.TotalRate = 0;

    this.UnplannedLoad = 0;
    this.BookingStatus = "";

    this.CourierDetail = [];
  }
}
